import { Routes } from '@angular/router';
import { TabTitleStrategyService } from '@sc/data-access-translation';
import { DossiersSearchComponent } from './containers/dossiers-search/components';
import { DossiersSearchContainer } from './containers/dossiers-search/container';
import { DossiersSearchGuardCanActivate } from './containers/dossiers-search/guards';

export const routes: Routes = [
  {
    path: '',
    component: DossiersSearchContainer,
    canActivate: [DossiersSearchGuardCanActivate],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.DossierSearch',
    },
    children: [
      {
        path: '',
        component: DossiersSearchComponent,
        data: {
          [TabTitleStrategyService.TAB_TITLE_KEY]:
            'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.DossierSearch',
        },
      },
    ],
  },
];
